// Английски превод — common. Ключ = българският текст от кода.
export const EN_COMMON: Record<string, string> = {
  // App.tsx — заключен екран, админ, заглавия на екраните
  'Здравейте, {name}': 'Hello, {name}',
  'Здравейте': 'Hello',
  'Въведете ПИН, за да продължите': 'Enter your PIN to continue',
  'Отключете, за да продължите': 'Unlock to continue',
  'Отключи с лице / отпечатък': 'Unlock with Face ID / fingerprint',
  'Изход от акаунта': 'Log out',
  'Този акаунт е за админ панела': 'This account is for the admin panel',
  'Влезте на admin.livupp.com. Приложението е за наемодатели, пропърти мениджъри, наематели, собственици, майстори и криейтъри.':
    'Log in at admin.livupp.com. The app is for landlords, property managers, tenants, owners, handymen and creators.',
  'Изход': 'Log out',
  'SMS код': 'SMS code',
  'Забравена парола': 'Forgotten password',
  'Регистрация': 'Sign up',
  'Провери наемател': 'Check a tenant',
  'Начало': 'Home',
  'Вашето име': 'Your name',
  'Имоти': 'Properties',
  'Имот': 'Property',
  'Статистика': 'Statistics',
  'Собственици': 'Owners',
  'Архивирани': 'Archived',
  'Собственик': 'Owner',
  'Минали наематели': 'Past tenants',
  'Обитатели': 'Residents',
  'Нов имот': 'New property',
  'Нов наемател': 'New tenant',
  'Нова сметка': 'New bill',
  'ИТН номер': 'Utility account number',
  'Протокол': 'Handover protocol',
  'Получаване на наема': 'Receiving the rent',
  'Нередности': 'Issues',
  'Ремонт / нередност': 'Repair / issue',
  'Майстори': 'Handymen',
  'Задържане': 'Hold',
  'Документи': 'Documents',
  'Фактури': 'Invoices',
  'Нова фактура': 'New invoice',
  'Договор за наем': 'Rental contract',
  'Корекция на фактура': 'Invoice correction',
  'Свободни апартаменти': 'Available apartments',
  'Нова обява': 'New listing',
  'Съобщения': 'Messages',
  'Разговор': 'Chat',
  'Оценка': 'Review',
  'Абонамент': 'Subscription',
  'Известия': 'Notifications',
  'Профил': 'Profile',
  'Поддръжка': 'Support',
  'Още': 'More',
  'Моят дом': 'My home',
  'Ремонти': 'Repairs',
  'Нова нередност': 'New issue',
  'Моите имоти': 'My properties',
  'Криейтър': 'Creator',
  'Пари': 'Money',
  'Покани': 'Invites',
  'Поръчки': 'Jobs',
  // ui.tsx
  'Готово': 'Done',
  // drawer / bottom-nav / web-sidebar — роли и менюта
  'Наемодател': 'Landlord',
  'Пропърти мениджър': 'Property manager',
  'Наемател': 'Tenant',
  'Майстор': 'Handyman',
  'Админ': 'Admin',
  'Модератор': 'Moderator',
  'Обитател': 'Resident',
  'Заявки': 'Requests',
  'Инструменти': 'Tools',
  'Архивирани имоти': 'Archived properties',
  'Акаунт': 'Account',
  'Наистина ли излизате от акаунта?': 'Are you sure you want to log out?',
  // toast.tsx
  'Възникна грешка.': 'Something went wrong.',
  'Отказ': 'Cancel',
  // legal.tsx
  'Общи условия': 'Terms of Service',
  'и': 'and',
  'Политика за поверителност': 'Privacy Policy',
  // photo-picker.ts / photo-viewer.tsx
  'Качването се провали.': 'Upload failed.',
  '{failed} от {total} снимки не се качиха.': '{failed} of {total} photos failed to upload.',
  'Затвори': 'Close',
  // settlement-picker.tsx
  'Изберете населено място': 'Choose a town or village',
  'Всички населени места': 'All towns and villages',
  'Области': 'Regions',
  'Търсене по име…': 'Search by name…',
  'Няма населено място с това име.': 'No town or village with that name.',
  'Изберете област': 'Choose a region',
  'Изберете области…': 'Choose regions…',
  // ErrorBoundary.tsx
  'Нещо се обърка.': 'Something went wrong.',
  'Презаредете страницата — ако проблемът остане, пишете ни на info@livupp.com.':
    'Reload the page — if the problem persists, email us at info@livupp.com.',
  'Презареди': 'Reload',
  // AuthContext.tsx
  'Отключете Livupp': 'Unlock Livupp',
  // iap.ts
  'Покупките през App Store са налични само на iPhone/iPad.': 'App Store purchases are available only on iPhone/iPad.',
  'Покупката не беше завършена. Опитайте отново.': 'The purchase was not completed. Please try again.',
  'Покупката чака одобрение (напр. „Поискай покупка“). Ще се активира след потвърждение.':
    'The purchase is awaiting approval (e.g. "Ask to Buy"). It will activate once confirmed.',
  '‹ Вход': '‹ Log in',
};
